import React from "react";
import Select from "react-select";

import { Editor } from "components";
import Constants from "app_constants";
import Theme from "./theme";

const jobCategories = Constants.jobCategories;
const options = [];

for (const key in jobCategories) {
  options.push({ value: key, label: jobCategories[key] });
}

const PublishJobView = (props) => {
  const {
    setFormData,
    post,
    publish,
    error,
    boostJobAd,
    isBoostingJobAd,
  } = props;

  return (
    <Theme>
      {Constants.metaTag}
      {error && <p className="error">An error occured. Please try again!</p>}
      <div className="field">
        <label className="label">Job Title</label>
        <div className="control">
          <input
            value={post.title}
            onChange={(e) => {
              setFormData("title", e.target.value);
            }}
            className="input is-info"
            type="text"
          />
        </div>
      </div>
      <div className="columns">
        <div className="column">
          <div className="field">
            <label className="label">Job Category</label>
            <div className="control">
              <Select
                options={options}
                onChange={(e) => {
                  setFormData("category", e.value);
                }}
                value={options.find((option) => option.value === post.category)}
              />
            </div>
          </div>
        </div>

        <div className="column">
          <div className="field">
            <label className="label">Job Type</label>
            <div className="jobType">
              <label className="radio">
                <input
                  checked={post.type === "full-time"}
                  onChange={() => {
                    setFormData("type", "full-time");
                  }}
                  type="radio"
                  name="rsvp"
                />
                &nbsp;
                <span>Full-Time</span>
              </label>
              <label className="radio">
                <input
                  checked={post.type === "contract"}
                  onChange={() => {
                    setFormData("type", "contract");
                  }}
                  type="radio"
                  name="rsvp"
                />
                &nbsp;
                <span>Contract</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className="field">
        <label className="label">Regional Restrictions</label>
        <div className="control">
          <input
            value={post.regionalRestrictions}
            onChange={(e) => {
              setFormData("regionalRestrictions", e.target.value);
            }}
            className="input is-info"
            type="text"
          />
        </div>
      </div>
      <div className="field">
        <label className="label">Application Link</label>
        <div className="control">
          <input
            value={post.link}
            onChange={(e) => {
              setFormData("link", e.target.value);
            }}
            className="input is-info"
            type="text"
          />
        </div>
      </div>
      <div className="field">
        <label className="label">Compensation</label>
        <div className="control">
          <input
            value={post.compensation}
            onChange={(e) => {
              setFormData("compensation", e.target.value);
            }}
            className="input is-info"
            type="text"
            placeholder="$40k - $70k"
          />
        </div>
      </div>
      <div className="field">
        <label className="label">Job Description</label>

        <Editor
          data={post.description}
          onChange={({ event, editor, data }) => {
            setFormData("description", data);
          }}
        />
      </div>
      {/*
      <label class="checkbox">
        <input
          type="checkbox"
          checked={isBoostingJobAd}
          onChange={(e) => {
            boostJobAd(e.target.checked);
          }}
        />
        <span>Boost Job Ad</span>
      </label>
      */}
      <br />
      <button onClick={publish} className="button is-info submit">
        Publish Job Ad
      </button>
    </Theme>
  );
};

export default PublishJobView;
